
    import './styles.scoped.css';
    export default {
  "notifications": "awsui_notifications_1hmm4_zmmyp_5",
  "notifications-sticky": "awsui_notifications-sticky_1hmm4_zmmyp_6",
  "no-content-paddings": "awsui_no-content-paddings_1hmm4_zmmyp_21"
};
  